// removed by extract-text-webpack-plugin
module.exports = {"actions":"merge-vendors-modal__actions___32hAS","text":"merge-vendors-modal__text___2l1M3"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-vendors/merge-vendors-modal.scss
// module id = 1346
// module chunks = 0